import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { CrisRequest } from 'app/model';
import { crisRequestService } from 'app/services/cris-request.service';
import { CrisListGrid } from 'features/cris/listing/cris-list-grid';

export const CrisRequestListing: React.FunctionComponent = () => {
    const [requests, setRequests] = useState<CrisRequest[]>([]);

    useEffect(() => {
        const sub = crisRequestService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
            })
            .subscribe((data) => {
                setRequests(data);
            });

        return () => {
            sub.unsubscribe();
        };
    }, []);

    return (
        <Box sx={{ minHeight: '30rem', height: '100%' }}>
            <CrisListGrid density='compact' pagination autoPageSize rows={requests} />
        </Box>
    );
};
